export const GreekLabel = {
  Enter_the_following_information_to_enter: 'Συμπληρώστε τα στοιχεία σας για να συνδεθείτε',
  login: 'Σύνδεση',
  Username: 'Όνομα Χρήστη',
  password: 'Κωδικός',
  Orders: 'Παραγγελίες',
  Online: 'Σε Σύνδεση',
  Offline: 'Εκτός Σύνδεσης',
  Info: 'Πληροφορίες',
  email: 'Email',
  vehicletypes: 'Τύποι Υπηρεσιών',
  loginstatus: 'Κατάσταση σύνδεσης',
  lastonlinetime: 'Τελευταία ώρα σύνδεσης',
  fetchingdata: 'Λήψη πληροφοριών...',
  poperLoading: 'Παρακαλώ περιμένετε',
  Noinformationfound: 'Δεν βρέθηκαν πληροφορίες',
  Drivers: 'Οδηγοί',
  otherdropoffs: 'Άλλες παραδόσεις',
  paymentmethod: 'Τρόπος πληρωμής',
  Receiver: 'Από παραλήπτη',
  Sender: 'Από αποστολέα',
  Balance: 'Υπόλοιπο',
  Cash: 'Μετρητά',
  Wallet: 'Πορτοφόλι',
  Close: 'Κλείσιμο',
  noVehicleType: 'Δεν υπάρχει τύπος υπηρεσίας προς εμφάνιση',
  Fname: 'Όνομα',
  Lname: 'Επώνυμο',
  Pnumber: 'Τηλέφωνο',
  driver: 'Οδηγός',
  Pleasetryanotherkeyword: 'Δοκιμάστε διαφορετική λέξη-κλειδί',
  'Încearcă alt cuvânt cheie': 'Bitte versuche eine anderes Keywort',
  DropOff: 'Παράδοση',
  Noaddressavailable: 'Δεν υπάρχει διαθέσιμη διεύθυνση',
  Managefavoriteaddresses: 'Διαχείριση διευθύνσεων',
  address: 'Διέυθυνση',
  Saved: 'Αποθηκευμένο',
  block: 'Οικοδομικό τετράγωνο',
  Floor: 'Όροφος',
  Unit: 'Διαμέρισμα',
  Recieverfullname: 'Όνομα παραλήπτη',
  Recieverphonenumber: 'Τηλέφωνο Παραλήπτη',
  notesfordriver: 'Σημείωση για τον οδηγό',
  Price: 'Τιμή',
  EditOrder: 'Επεξεργασία Παραγγελίας',
  Firstname: 'Όνομα',
  Lastname: 'Επώνυμο',
  Phonenumber: 'Τηλέφωνο',
  senderfullname: 'Όνομα Αποστολέα',
  senderphonenumber: 'Τηλέφωνο Αποστολέα',
  Search: 'Αναζήτηση',
  Service: 'Υπηρεσία',
  Passenger: 'Πελάτης',
  Pickup: 'Σημείο Παραλαβής',
  Pricedetails: 'Λεπτομέρειες τιμής',
  Fee: 'Χρέωση',
  Fornow: 'Άμεσα',
  Scheduled: 'Προγραμματισμένο',
  before: 'Πριν: ',
  Settime: 'Καταχώρηση ώρας',
  after: 'Μετά:',
  confirm: 'Επιβεβαίωση',
  Cancel: 'Ακύρωση',
  Addresses: 'Διευθύνσεις',
  Savedaddresses: 'Αποθηκευμένες Διευθύνσεις',
  new: 'Νέα',
  Editaddress: 'Επεξεργασία διεύθυνσης',
  Saveaddress: 'Αποθήκευση διεύθυνσης',
  Language: 'Γλώσσα',
  en: 'Αγγλικά',
  fa: 'Περσικά',
  English: 'Αγγλικά',
  Persian: 'Περσικά',
  Logout: 'Αποσύνδεση',
  logotTitle: 'Αποσύνδεση απο τον λογαριασμό σας;',
  logoutDescription: 'Θα αποσυνδεθείτε απο τον λογαριασμό και θα απαιτείτε εκ νέου σύνδεση ',
  confirmLogout: 'Επιβεβαίωση',
  skipLogout: 'Ακύρωση',
  Ascending: 'Αύξουσα',
  Descending: 'Φθίνουσα',
  'sort[createdAt]': 'Ημερομηνία',
  'sort[pickupScheduleDate]': 'Ώρα προγραμματισμένης παραλαβής',
  'sort[statusUpdatedAt]': 'Ταξινόμηση κατά τελευταία ενημέρωση',
  SelectDateRange: 'Εύρος ημερομηνιών',
  StartDate: 'Ημερομηνία Έναρξης',
  EndDate: 'Ημερομηνία Λήξης',
  Today: 'Σήμερα',
  Yesterday: 'Χθες',
  ThisWeek: 'Αυτή την εβδομάδα',
  LastWeek: 'Προηγούμενη εβδομάδα',
  Last7Days: 'Τελευταίες 7 ημέρες',
  ThisMonth: 'Αυτός ο Μήνας',
  LastMonth: 'Προηγούμενος Μήνας',
  monitoring: 'Παρακολούθηση',
  Haveorder: 'Υπάρχει Παραγγελία',
  Estimated: 'Εκτιμώμενος',
  ReceiverCash: 'Μετρητά (παραλήπτη)',
  SenderCash: 'Μετρητά',
  SenderWallet: 'Πορτοφόλι',
  Auto: 'Αυτόματα',
  Manual: 'Χειροκίνητη',
  SendOrderr: 'Αποστολή',
  Neworder: 'Νέα Παραγγελία',
  Person: 'Ιδιώτης',
  Business: 'Επιχείρηση',
  Businessname: 'Όνομα Επιχείρησης ',
  phonenumber: 'Τηλέφωνο',
  Adddropoff: 'Προσθήκη σημείου παράδοσης',
  Searchbynameorphonenumber: 'Αναζήτηση σύμφωνα με όνομα ή τηλέφωνο',
  Fullname: 'Όνομα/Επώνυμο',
  type: 'πληκτρολόγηση',
  only: 'xxx μόνο',
  ChooseDriver: 'Επιλογή Οδηγού',
  AllKey: 'Όλες',
  MeKey: 'Εγώ',
  Vehicletype: 'Τύπος οχήματος',
  status: 'Κατάσταση',
  statusInProgress: 'Σε εξέλιξη',
  statusCanceled: 'Ακυρώθηκε',
  statusPending: 'Σε εκκρεμότητα',
  statusUnassigned: 'Χωρίς Ανάθεση',
  statusDone: 'Ολοκληρωμένες',
  dispatcher: 'Χειριστής',
  customer: 'τηλέφωνο',
  regexcode: 'Κωδικός',
  regexcustomerPhone: 'Ακυρώθηκε από πελάτη',
  regexcustomerName: 'Όνομα Πελάτη',
  regexdriverPhone: 'Τηλέφωνο Οδηγού',
  regexdriverName: 'Όνομα Οδηγού',
  regexdriverUsername: 'Username Οδηγού',
  pickupDescription: 'Περιγραφή παραλαβής',
  filter: 'Φίλτρο',
  clear: 'Εκκαθάριση',
  orderInfoError: 'Σφάλμα λήψης πληροφοριών',
  Details: 'Λεπτομέρειες',
  History: 'Ιστορικό',
  Phone: 'Τηλέφωνο',
  km: 'χλμ',
  Espath: 'Εκτ.Διαδρομή',
  Receipt: 'Απόδειξη',
  Copylink: 'Αντιγραφή συνδέσμου',
  repeatOrder: 'Επανάληψη Παραγγελίας',
  Edit: 'Επεξεργασία',
  EditPrice: 'Επεξεργασία τιμής',
  Endtrip: 'Ολοκλήρωση παραγγελίας',
  Canceltravel: 'Ακύρωση παραγγελίας',
  CancellText: 'Μετά την ακύρωση, η παραγγελία ακυρώνεται για τον οδηγό',
  confirmCancel: 'Ναι',
  Endtravel: 'Ολοκλήρωση ',
  EndlText: 'Με την ολοκλήρωση, η παραγγελία για τον Πελάτη και τον οδηγό ολοκληρώνεται με επιτυχία και το ποσό αφαιρείται από τον λογαριασμό του Πελάτη',
  confirmEnd: 'Ναι',
  End: 'Ακύρωση Παραγγελίας',
  Deliveredat: 'Παραδόθηκε σε',
  pod: 'Απόδειξη παράδοσης',
  Notes: 'Σημείωση',
  Nonotes: 'Καμία σημείωση',
  Photo: 'Φωτογραφία',
  Signature: 'Υπογραφή',
  Nosignature: 'Καμία υπογραφή',
  Nophoto: 'Καμία φωτογραφία',
  ServiceOptions: 'Επιλογές υπηρεσίας',
  Events: 'Συμβάντα',
  status2: 'Κατάσταση',
  Creator: 'Δημιουργός',
  Creationdate: 'Ημερομηνία δημιουργίας',
  Orderid: 'ID παραγγελίας',
  Pickup2: 'Παραλαβή',
  Dropoff2: 'Παράδοση',
  PleaseSelect: 'Παρακαλώ Επιλέξτε',
  CreateEvent: 'Δημιουργία συμβάντος',
  Description: 'Περιγραφή',
  detailsAboutEvent: 'Λεπτομέρειες συμβάντος',
  CustomerVisibility: 'Όρατότητα πελάτη',
  LocationOnMap: 'Τοποθεσία στον χάρτη',
  Pending: 'Σε εκρεμμότητα',
  Unassigned: 'Χωρίς Ανάθεση',
  Assigned: 'Σε εξέλιξη',
  PickedUp: 'Σε εξέλιξη',
  Started: 'Σε εξέλιξη',
  Done: 'Ολοκληρώθηκε',
  CustomerCanceled: 'Ακυρώθηκε',
  DriverCanceled: 'Ακυρώθηκε',
  SupportCanceled: 'Ακυρώθηκε',
  Arrived: 'Σε εξέλιξη',
  Createdsuccessfully: 'Δημιουργήθηκε επιτυχώς',
  Estime: 'Εκτιμώμενος χρόνος',
  Promocode: 'Κουπόνι',
  Updatedsuccessfully: 'Ενημερώθηκε επιτυχώς',
  statusAssigned: 'Ανατέθηκε',
  statusStarted: 'Ξεκίνησε',
  statusPickedUp: 'Ξεκίνησε',
  statusDriverCanceled: 'Ακυρώθηκε από οδηγό',
  statusArrived: 'Έφτασε',
  statusSupportCanceled: 'Ακυρώθηκε απο Διαχείριση',
  Title: 'Τίτλος',
  ContactFullname: 'Όνομα Επαφής',
  Contactphonenumber: 'Τηλέφωνο Επαφής',
  Commission: 'Προμήθεια',
  surcharge: 'Έξτρα χρέωση',
  haslogined: 'Συνδέθηκε',
  Notloggedin: 'Δεν έχει συνδεθεί',
  Schedule: 'Προγρ/σμός',
  Date: 'Ημερομηνία',
  Time: 'Ώρα',
  noDateToShow: 'Δεν υπάρχει ημερομηνία προς προβολή',
  noTimeToShow: 'Δεν υπάρχει ώρα προς προβολή',
  Apply: 'Επιβεβαίωση',
  lowBalance: 'Χαμηλό υπόλοιπο',
  balanceError: 'Το υπόλοιπο σας πρέπει να είναι τουλάχιστον ίσο με το κόστος της παραγγελίας',
  Methods: 'Τρόποι Πληρωμής',
  Addressbook: 'Αποθηκευμένες Διευθύνσεις',
  AddressbookSearchbar: 'Αναζήτηση βάση διεύθυνσης, τίτλου και ID ',
  AddressbookDropOf: 'Αποθ/μένες Διευθύνσεις',
  AddressbookPickup: 'Αποθ/μένες Διευθύνσεις',
  hide: 'Απόκρυψη',
  Nosavedaddress: 'Δεν υπάρχουν αποθηκευμένες διευθύνσεις',
  Romanian: 'Ρουμανικά',
  business: 'Επιχείρηση',
  username: 'Όνομα Χρήστη',
  rememberme: 'Θυμήσου με',
  SendOrder: 'Αποστολή',
  code: 'Κωδικός',
  noorder: 'καμία παραγγελία',
  pleaseSellectParsel: 'Επιλέξτε Υπηρεσία',
  Order: 'Παραγγελία',
  Code: 'Κωδικός',
  Editorder: 'Επεξεργασία Παραγγελίας',
  all: 'Όλες',
  Address: 'Διευθύνσεις',
  'Block/Building': 'Κτήριο',
  Pickedupat: 'Παραλήφθηκε σε',
  for: 'Για',
  fr: 'Γαλλικά',
  AllVehicletypes: 'Όλοι οι τύποι υπηρεσιών',
  AllServices: 'Όλες οι Υπηρεσίες',
  French: 'Γαλλικά',
  enterDataCorrectly: 'Καταχωρήστε τα στοιχεία σωστά',
  controlThatbeforeLoweEqualAfter: 'Η Ώρα ""Πριν:"" δεν μπορεί να είναι νωρίτερα από "" Μετά:""',
  ForceAssign: 'Αναγκαστική Ανάθεση',
  Allvehicletypes: 'Όλοι τύποι οχημάτων',
  waitforconfirm: 'xxx (Αναμονή Επιβεβαίωσης)',
  waitforconfirm2: '(Αναμονή Επιβεβαίωσης)',
  Dispatching: 'Αποστολή ',
  NoDriver: 'Κανένας Οδηγός',
  OtherDetails: 'Άλλες Λεπτομέρειες',
  StatusandDriver: 'Κατάσταση και Οδηγός',
  EditStatusandDriver: 'Επεξεργασία Κατάστασης και Οδηγού',
  Current: 'Τρέχων',
  EDAS_Pending: 'Σε εξέλιξη',
  EDAS_Assigned: 'Ανατέθηκε',
  EDAS_PickedUp: 'Παραλήφθηκε',
  EDAS_Unassigned: 'Χωρίς Ανάθεση',
  EDAS_Started: 'Ξεκίνησε',
  EDAS_Done: 'Ολοκληρώθηκε',
  EDAS_CustomerCanceled: 'Ακύρωση από πελάτη',
  EDAS_DriverCanceled: 'Ακύρωση από οδηγό',
  EDAS_SupportCanceled: 'Ακύρωση από Υποστήριξη',
  EDAS_Arrived: 'Έφτασε',
  Pleasechooseadrivertochangestatus: 'Η Αλλαγή επιλογών μπορεί να επηρεάσει την τιμή',
  icWarningEdit: 'Ο τύπος οχήματος θα αλλάξει',
  Vehicletypewillbechanged: 'Ο τύπος οχήματος θα αλλάξει και θα επηρεάσει την τελική τιμή',
  Yourcurrentvehicletypeanditwillbechangedandeffectsonprice: 'Ο τρέχων τύπος οχήματος θα αλλάξει και θα επηρεάσει την τιμή',
  Rejected: 'Απορρίφθηκε',
  Rejected2: '(Απορρίφθηκε)',
  DriverVehicleTypeError: 'Δεν υπάρχει τύπος οχήματος για τον οδηγό',
  CodeNameFamilyPhonenumber: 'Κωδικός, Όνομα,Επώνυμο, Τηλέφωνο',
  youcanselectdriverintheedit: 'Μπορεί να επιλεχθεί οδηγός στην Επεξεργασία Κατάστασης και Οδηγού',
  Earning: 'Έσοδα',
  savePrice: 'Αποθήκευση τιμής',
  saveEarning: 'Αποθήκευση Εσόδων',
  Total: 'Σύνολο',
  EditPickupDropOff: 'Διευθύνσεις',
  noMoreData: 'Δεν υπάρχουν άλλες πληροφορίες',
  OnDemand: 'Κατά παραγγελία',
  PD: 'Παραλαβή & Παράδοση',
  PD2: 'Παραλαβή & Παράδοση 2',
  PickupDropoff: 'Παραλαβή, Παράδοση',
  PickupFlag: 'Παραλαβή',
  DropOffFlag: 'Παράδοση',
  PickupandDelivery: 'Παραλαβή και Παράδοση',
  PickupDelivery: 'Παραλαβή και Παράδοση',
  Delivery: 'Παράδοση',
  Collecting: 'Περισυλλογή',
  Transit: 'Σε μεταφορά',
  Delivering: 'Προς παράδοση',
  EDAS_Collecting: 'Περισυλλογή',
  EDAS_Transit: 'Σε μεταφορά',
  EDAS_Delivering: 'Προς παράδοση',
  statusCollecting: 'Περισυλλογή',
  statusTransit: 'Σε μεταφορά',
  statusDelivering: 'Προς παράδοση',
  serviceCustomerError1: 'Το xxx δεν είναι διαθέσιμη για αυτόν τον πελάτη',
  serviceCustomerError2: 'Μπορεί να επιλέξει μόνο τη xxx Υπηρεσία',
  serviceCustomerError3: 'Μπορεί να επιλέξει μόνο το xxx',
  OrderCode: 'Κωδικός Παραγγελίας',
  event_Created: 'Δημιουργήθηκε',
  event_Unassigned: 'Χωρίς Ανάθεση',
  event_Assigned: 'Ανατέθηκε',
  event_Started: 'Ξεκίνησε',
  event_Arrived: 'Έφτασε',
  event_PickedUp: 'Παραλήφθηκε',
  event_OrderDone: 'Η Παραγγελία ολοκληρώθηκε',
  event_DropoffDone: 'Έγινε Παράδοση',
  event_CustomerFeedback: 'Σχόλια πελάτη',
  event_AddPod: 'Προσθήκη Απόδειξης Παράδοσης (POD)',
  event_CustomerCanceled: 'Ο πελάτης Ακύρωσε',
  event_DriverCanceled: 'Ο οδηγός ακύρωσε',
  event_SupportCanceled: 'Η υποστήριξη ακύρωσε',
  event_Updated: 'Ενημερώθηκε',
  event_DriverAssignment: 'Ανάθεση Οδηγού',
  event_DriverReject: 'Αππόριψη από οδηγό',
  event_Collecting: 'Περισυλλογή',
  event_InTransit: 'Σε μεταφορά',
  event_Delivering: 'Προς παράδοση',
  event: 'Συμβάν',
  tab_Delivery: 'Παράδοση',
  tab_Ondemand: 'Κατά παραγγελία',
  tab_Pickup: 'Παραλαβή',
  tab_PickupDelivery: 'Παραλαβή και Παράδοση',
  CurrentStatus: 'Τρέχουσα Κατάσταση',
  Changestatus: 'Αλλαγή κατάστασης',
  Newstatus: 'Νέα κατάσταση',
  Savechanges: 'Αποθήκευση αλλαγών',
  Other: 'Άλλα',
  Shipmentlabel: 'Ετικέτα αποστολής',
  pleaseSellectService: 'Επιλέξτε είδος υπηρεσίας',
  EditPrice2: 'Τιμή',
  EditEarning: 'Κέρδος',
  statusCustomerCanceled: 'Ακυρώθηκε απο πελάτη',
  Dutch: 'Dutch',
  Ondemand: 'Κατά παραγγελία',
  todayat: 'Σήμερα στις',
  tomorrowat: 'Αύριο στις',
  nextWeekat: 'Την επόμενη εβδομάδα στις',
  lastDayat: 'Την επόμενη ημέρα στις',
  lastWeekat: 'Την προηγούμενη εβδομάδα στις',
  CopyOrderlink: 'Αντιγραφή συνδέσμου παραγγελίας',
  CopyPickuplink: 'Αντιγραφή συνδέσμου παραλαβής',
  CopyDeliverylink: 'Αντιγραφή συνδέσουμε παράδοσης',
  Bulkimport: 'Μαζική εισαγωγή',
  Downloadsamplecsv: 'Κατεβάστε ένα δείγμα CSV',
  processing: 'Επεξεργασία',
  done: 'Ολοκληρώθηκε',
  failed: 'Απέτυχε',
  Draft: 'Πρόχειρο',
  Uploading: 'Μεταφόρτωση',
  Draganddropyourfile: 'Σύρετε και αφήστε το αρχείο σας',
  Onlycsvformatissupported: ' Υποστηρίζονται Μόνο αρχεία .csv',
  ORyoucan: 'Ή μπορείτε',
  Openfile: 'Άνοιγμα αρχείου',
  Noimportsyet: 'Καμία μεταφόρτωση ακόμα',
  NoimportsyetDesc: 'Μπορείτε να δείτε τη λίστα με τις εισαγωγές σας εδώ και να ελέγξετε την κατάστασή τους',
  nosupportdialogeTitle: 'Αυτός ο τύπος αρχείου δεν υποστηρίζεται',
  nosupportdialogeText: 'Το αρχείο xxx δεν υποστηρίζεται. Μπορείτε να ανεβάσετε μόνο αρχείο .csv συμπεριλαμβανομένων των πληροφοριών παραγγελίας',
  ok: 'OK',
  Import: 'Εισαγωγή',
  previewTitle: 'Προεπισκόπηση και επιλογή',
  previewDesc: 'Αυτό είναι το πρώτο στοιχείο των αρχείων σας για να ελέγξετε ότι οι πληροφορίες σας είναι στη σωστή δομή',
  Upload: 'Μεταφόρτωση',
  Remove: 'Αφαίρεση',
  ServiceandOrdertype: 'Υπηρεσία και Τύπος Παραγγελίας',
  Fileisproccessing: 'Γίνεται επεξεργασία του αρχείου...',
  proccessingDesc: 'Μπορείτε να κάνετε ανανέωση για να δείτε αν το αποτέλεσμα είναι έτοιμο',
  serverError: 'Σφάλμα Διακομιστή',
  isRequired: 'xxx είναι απαραίτητο',
  Result: 'Αποτέλεσμα',
  ResultText: 'Μπορείτε να δείτε τα προβλήματα εδώ και μπορείτε επίσης να κάνετε λήψη αυτών των σειρών για να τα διορθώσετε',
  ErrorDetails: 'Παραγγελίες με σφάλμα',
  ErrorDetailsText: 'Οι παραγγελίες με σφάλματα παρατίθενται στο αρχείο που μπορείτε να κατεβάσετε παρακάτω. Περιέχει λεπτομέρειες σφάλματος για κάθε σειρά.',
  DownloadErroredRows: 'Κατεβάστε τις εσφαλμένες γραμμές',
  importedsuccessfully: 'xxx παραγγελίες έχουν εισαχθεί επιτυχώς',
  ordershaserrors: 'xxx παραγγελίες έχουν σφάλμα',
  refresh: 'Ανανέωση',
  CashOnDelivery: 'Αντικαταβολή',
  EnterAmount: 'Συμπληρώστε το ποσό',
  COD: 'Ανικαταβολή',
  Surchargexxx: 'Πρόσθετη χρέωση xxx',
  AddCreditCard: 'Προσθήκη Κάρτας',
  CustomerWallet: 'Πορτοφόλι πελάτη',
  Add: 'Προσθήκη',
  Addedsuccessfully: 'Προστέθηκαν επιτυχώς',
  NoRecentAddress: 'Καμία πρόσφατη διεύθυνση',
  NoRecentAddressD: 'Οι τελευταίες διευθύνσεις του πελάτη θα αναφέρονται εδώ',
  CustomerIsNotChoosed: 'Δεν έχει επιλεχθεί πελάτης',
  CustomerIsNotChoosedD: 'Επιλέξτε έναν πελάτη για εμφάνιση (προβολή) της τελευταίας διεύθυνσης',
  SearchAddress: 'Αναζήτηση διεύθυνσης',
  NoCustomerfound: 'Δεν βρέθηκε πελάτης',
  NoCustomerfoundD: 'Εάν ο πελάτης είναι νέος, μπορείτε να τον καταχωρήσετε',
  NewCustomer: 'Νέος Πελάτης',
  Existing: 'Υπάρχον',
  EmailOtional: 'Email (Προεραιτικό)',
  phonenumberisnotcorrect: 'ο αριθμός τηλεφώνου δεν είναι σωστός',
  Emailisnotcorrect: 'Το Email δεν είναι σωστό',
  Registercustomer: 'Εγγραφή πελάτη',
  incoming: 'Εισερχόμενη κλήση',
  outgoing: 'Εξερχόμενη κλήση',
  recording: 'Καταγραφή κλήσης',
  driveroperatorCallStatus: 'Ο οδηγός κάλεσε τον διαχειριστή',
  customeroperatorCallStatus: 'Ο πελάτης κάλεσε τον διαχειριστή',
  newCustomeroperatorCallStatus: 'Νέος πελάτης κάλεσε τον διαχειριστή',
  operatordriverCallStatus: 'Ο Διαχειριστής κάλεσε τον οδηγό',
  operatorcustomerCallStatus: 'Ο διαχειριστής κάλεσε τον πελάτη',
  operatornewCustomerCallStatus: 'Ο διαχειριστής κάλεσε τον νέο πελάτη',
  dispatcher_Voip: 'Διαχειριστής',
  driver_Voip: 'Οδηγός',
  customer_Voip: 'Πελάτης',
  activeorders: 'xxx ενεργές παραγγελίες',
  Noactiveorder: 'Καμία ενεργή παραγγελία',
  CreateOrder: 'Δημιουργία Παραγγελίας',
  call: 'Κλήση',
  spanish: 'Ισπανικά',
  es: 'Ισπανικά',
  networkError: 'Δεν υπάρχει σύνδεση στο διαδίκτυο',
  germany: 'Γερμανικά',
  de: 'Γερμανικά',
  Itisnotpossibletorepeattherequest: 'Η παραγγελία δεν μπορεί να επαναληφθεί',
  createdAt: 'Δημιουργήθηκε στις',
  dueDate: 'Ημερομηνία λήξης',
  Noresultfound: 'Δεν βρέθηκε κάποιο αποτέλεσμα',
  loadMore: 'Περισσότερα',
  Searchresult: 'Αναζήτηση αποτελέσματος',
  AssignedAt: 'Ανάθεση μέχρι xxx',
  StartedAt: 'Έναρξη μέχρι xxx',
  ArrivedAt: 'Άφιξη μέχρι xxx',
  PickedUpAt: 'Παραλαβή σε xxx',
  DoneAt: 'Ολοκλήρωση σε xxx',
  mindelay: 'xxxm καθυστέρηση',
  minlate: 'xxxm καθυστέρηση',
  PinTop: 'Καρφίτσωμα',
  UnPin: 'Ξεκαρφίτσωμα',
  Itemsonmap: 'Αντικείμενα στον χάρτη',
  min: 'xxx λεπτά',
  Confirming: 'Γίνεται επιβεβαίωση',
  delay: 'Καθυστέρηση',
  late: 'Εκπρόθεσμος',
  OrderDetails: 'Λεπτομέρειες Παραγγελίας',
  Profile: 'Προφίλ',
  Waitingforavailabledrivers: 'Αναμονή για διαθεσιμότητα οδηγών',
  Queue: 'Σειρά',
  OfferingToDrivers: 'Προσφορά σε xxx οδηγούς',
  WaitforAccept: 'Αναμονή Αποδοχής',
  Thereisnoorder: 'Δεν υπάρχει παραγγελία',
  mapitems: 'Αντικείμενα χάρτη',
  Offerings: 'Προσφορές',
  Reject: 'Απόρριψη',
  dropoffCustomerDescription: 'Σημείωση Παράδοσης',
  customerPhoto: 'Φωτογραφία Πελάτη',
  driverPhoto: 'Φωτογραφία Οδηγού',
  NocustomerPhoto: 'Καμία Φωτογραφία Πελάτη',
  NodriverPhoto: 'Καμία Φωτογραφία Οδηγού',
  initial: 'αρχική',
  notifying: 'Ειδοποίηση',
  received: 'Παραλήφθηκε',
  assigned: 'Ανατέθηκε',
  rejected: 'Απορρίφθηκε',
  canceled: 'Ακυρώθηκε',
  standby: 'Σε αναμονή',
  terminated: 'Τερματίστηκε',
  urgentTitle: 'Αντικατάσταση με Επείγουσα παράδοση;',
  urgentDesc: 'Αν η παραγγελία χαρακτηριστεί ώς επείγουσα τότε θα έχει προτεραιότητα για αποστολή',
  urgentConfirm: 'Ναι, αλλαγή σε Επείγουσα',
  urgentClose: 'Ακύρωση',
  Urgent: 'Επείγον',
  photos: 'Φωτογραφίες',
  Portuguese: 'Πορτογαλικά',
  Dispatchat: 'Αποστολή στις xxx',
  AutoDispatch: 'Αυτόματη Ανάθεση',
  Dispatchtime: 'Ώρα Ανάθεσης',
  Later: 'Αργότερα',
  DispatchingNow: 'Αποστολή τώρα',
  NoResultfromLocalDatabase: 'Κανένα αποτέλεσμα από την τοπική βάση δεδομένων',
  NoResultfromLocalDatabaseD: 'Ελέγξτε ξανά ή δοκιμάστε άλλη λέξη-κλειδί',
  NoResultfromMapService: 'Δεν Υπάρχουν Αποτελέσματα από την Υπηρεσία Χάρτη',
  now: 'Τώρα',
  ascending: 'Αύξουσα',
  descending: 'Φθίνουσα',
  Last3Month: 'Τελευταίοι 3 Μήνες',
  Pickupnote: 'Σημείωση Παραλαβής',
  pop: 'Αποδεικτικό Παραλαβής',
  Required: 'Απαιτείται',
  SearchinMapService: 'Αναζήτηση στον χάρτη',
  SearchinLocalDatabase: 'Αναζήτηση στην Τοπική βάση δεδομένων',
  Creditcardnotadded: 'Δεν έχει προστεθεί Κάρτα',
  OptimizeDropoffs: 'Βελτιστοποίηση Παραδόσεων',
  Greek: 'Ελληνικά',
  el: 'Ελληνικά',
  ReferenceID: 'Αναγνωριστικό αναφοράς',
  EnterId: 'Εισαγάγετε ID',
  German: 'Γερμανικά',
  AustrianGerman: 'Αυστριακά Γερμανικά',
  EDAS_PickupFailed: 'Αποτυχία Παραλαβής',
  EDAS_Lost: 'Χαμένο',
  EDAS_Returned: 'Επιστράφηκε',
  EDAS_Draft: 'Πρόχειρο',
  EDAS_Confirmed: 'Επιβεβαιωμένο',
  EDAS_PickupRouted: 'Διαδρομή Παραλαβής',
  EDAS_ReadyForPickup: 'Έτοιμο για Παραλαβή',
  EDAS_AtWarehouse: 'Στην Αποθήκη',
  EDAS_DeliveryRouted: 'Διαδρομή Παράδοσης',
  EDAS_ReadyForDelivery: 'Έτοιμο προς Παράδοση',
  EDAS_OutForDelivery: 'Σε Διανομή',
  EDAS_Delivered: 'Παραδόθηκε',
  EDAS_NotDelivered: 'Δεν Παραδόθηκε',
  EDAS_ForReturn: 'Προς Επιστροφή',
  Options: 'Επιλογές',
  VehicleOptions: 'Επιλογές Οχήματος',
  EditCustomer: 'Επεξεργασία Πελάτη',
  NoDriverfound: 'Δεν βρέθηκε οδηγός',
  NoDriverfoundDesc: 'Ελέγξτε τις πληροφορίες σας και δοκιμάστε ξανά',
  ClearField: 'Εκκαθάριση Πεδίου',
  Map: 'Χάρτης',
  Local: 'Τοπικό',
  CompleteRequiredFeileds: 'Συμπληρώστε τα υποχρεωτικά πεδία',
  Senderinfo: 'Πληροφορίες Αποστολέα',
  Receiverinfo: 'Πληροφορίες Παραλήπτη',
  'SchedulePickup(Optional)': 'Προγραμματισμός Παραλαβής (Προαιρετικό)',
  'ScheduleDelivery(Optional)': 'Προγραμματισμός Παράδοσης (Προαιρετικό)',
  AddDropoff: 'Προσθήκη Παράδοσης',
  Promotion: 'Προσφορά',
  tax: 'Φόρος',
  Shipmentlabeldownloaded: 'Η ετικέτα αποστολής κατέβηκε',
  statusDraft: 'Πρόχειρο',
  statusConfirmed: 'Επιβεβαιωμένο',
  statusPickupRouted: 'Διαδρομή Παραλαβής',
  statusReadyForPickup: 'Έτοιμο για Παραλαβή',
  statusAtWarehouse: 'Στην Αποθήκη',
  statusDeliveryRouted: 'Διαδρομή Παράδοσης',
  statusReadyForDelivery: 'Έτοιμο για Παράδοση',
  statusOutForDelivery: 'Σε Διανομή',
  statusDelivered: 'Παραδόθηκε',
  statusNotDelivered: 'Δεν Παραδόθηκε',
  statusForReturn: 'Προς Επιστροφή',
  statusReturned: 'Επιστράφηκε',
  statusPickupFailed: 'Αποτυχημένη Παραλαβή',
  statusLost: 'Χαμένο',
  event_Draft: 'Πρόχειρο',
  event_Confirmed: 'Επιβεβαιωμένο',
  event_PickupRouted: 'Διαδρομή Παραλαβής',
  event_ReadyForPickup: 'Έτοιμο για Παραλαβή',
  event_AtWarehouse: 'Στην Αποθήκη',
  event_DeliveryRouted: 'Διαδρομή Παράδοσης',
  event_ReadyForDelivery: 'Έτοιμο για Παράδοση',
  event_OutForDelivery: 'Σε Διανομή',
  event_Delivered: 'Παραδόθηκε',
  event_NotDelivered: 'Δεν Παραδόθηκε',
  event_ForReturn: 'Για Επιστροφή',
  event_Returned: 'Επιστράφηκε',
  event_PickupFailed: 'Αποτυχημένη Παραλαβή',
  event_Lost: 'Χαμένο',
  event_IncomingCall: 'Εισερχόμενη Κλήση',
  event_OutgoingCall: 'Εξερχόμενη Κλήση',
  event_DispatchOrder: 'Ανάθεση Παραγγελίας',
  tryagain: 'Κάτι πήγε στραβά, δοκιμάστε ξανά',
  'Selected date and time': 'Επιλεγμένη Ημερομηνία και Ώρα',
  'Reorder stops': 'Αναδιάταξη Στάσεων',
  'Bulk Edit Status Summary': 'Μαζική Επεξεργασία Περίληψης Κατάστασης',
  Successful: 'Επιτυχής',
  Failed: 'Αποτυχημένη',
  'Order ID': 'Αριθμός Παραγγελίας',
  'Pickup Routed': 'Διαδρομή Παραλαβής',
  'Delivery Routed': 'Διαδρομή Παράδοσης',
  'Ref. xxx': 'Αναφ. xxx',
  Zone: 'Ζώνη',
  Clear: 'Εκκαθάριση',
  'No result found': 'Δεν βρέθηκαν αποτελέσματα',
  'Type your keyword': 'Πληκτρολογήστε τη λέξη-κλειδί',
  'Type in the input to start search': 'Πληκτρολογήστε για Αναζήτηση',
  'We are sorry ...': 'Λυπούμαστε ...',
  'The page you are trying to access has restricted access.': 'Η Σελίδα που Προσπαθείτε να Ανοίξετε Έχει Περιορισμένη Πρόσβαση.',
  'Please refer to your system administrator.': 'Απευθυνθείτε στον Διαχειριστή του Συστήματος.',
  'Proof of delivery': 'Απόδειξη Παράδοσης',
  'Driver Photo': 'Φωτογραφία Οδηγού',
  'Order Info': 'Πληροφορίες Παραγγελίας',
  'P_HUB_D Orders': 'Παραγγελίες P_HUB_D',
  Routes: 'Διαδρομές',
  'Default pickup': 'Προεπιλεγμένη Παραλαβή',
  More: 'Περισσότερα',
  'Route name': 'Όνομα Διαδρομής',
  Driver: 'Οδηγός',
  'Pickup Orders': 'Παραγγελίες Παραλαβής',
  'Delivery Orders': 'Παραγγελίες Παράδοσης',
  'Ready For Pickup': 'Έτοιμο για Παραλαβή',
  PricingAndEarning: 'Τιμολόγηση & Έσοδα',
  Pricing: 'Τιμολόγηση',
  save: 'Αποθήκευση',
  Learn: 'Μάθετε',
  Scheduleoverlap: 'Η Ώρα Προγραμματισμένης Παραλαβής Πρέπει να Είναι Πριν την Ώρα Παράδοσης και να Μην Υπάρχει Αλληλεπικάλυψη',
  PleaseSelectCustomer: 'Επιλέξτε πελάτη',
  NoRegisteredCustomer: 'Δεν υπάρχει καταχωρημένος πελάτης',
  CreateAtLeastOneCustomerToCreateOrder: 'Δημιουργήστε Τουλάχιστον Έναν Πελάτη για να Δημιουργήσετε Παραγγελία',
  Pinned: 'Καρφιτσωμένο',
  Delayed: 'Σε καθυστέρηση',
  Canceled: 'Ακυρώθηκε',
  InProgress: 'Σε εξέλιξη',
  DispatchLater: 'Αποστολή αργότερα',
  Table: 'Πίνακας',
  'Clear All': 'Εκκαθάριση όλων',
  'Config Table': 'Διαμόρφωση πίνακα',
  'Active Columns': 'Ενεργές στήλες',
  'Due time': 'Προθεσμία',
  'Search route name': 'Αναζήτηση ονόματος διαδρομής',
  'Add Route': 'Προσθήκη διαδρομής',
  'Route info': 'Πληροφορίες διαδρομής',
  'Start Location': 'Τοποθεσία εκκίνησης',
  'End Location ( Optional )': 'Τοποθεσία τερματισμού (Προαιρετικό)',
  'Load Deliveries:': 'Φόρτωση παραδόσεων:',
  No: 'Όχι',
  Optional: 'Προαιρετικό',
  Force: 'Επιβολή',
  'Code, Name, Family, Phone number': 'Κωδικός, Όνομα, Επώνυμο, Τηλέφωνο',
  'Edit Route Status & Driver': 'Επεξεργασία κατάστασης διαδρομής & οδηγού',
  'No, Cancel': 'Όχι, Ακύρωση',
  'Yes, Optimize': 'Ναι, Βελτιστοποίηση',
  'Optimize Stops?': 'Βελτιστοποίηση στάσεων;',
  'The sequence of stops changes automatically. you can change it manually later': 'Η σειρά των στάσεων αλλάζει αυτόματα. Μπορείτε να την αλλάξετε χειροκίνητα αργότερα',
  'Error in loading data': 'Σφάλμα κατά τη φόρτωση δεδομένων',
  'There was a problem loading data. please try again or contact support': 'Παρουσιάστηκε πρόβλημα κατά τη φόρτωση δεδομένων. Δοκιμάστε ξανά ή επικοινωνήστε με την υποστήριξη',
  'Try again': 'Δοκιμάστε ξανά',
  'Duration:': 'Διάρκεια:',
  'Edit Route info': 'Επεξεργασία πληροφοριών διαδρομής',
  'Edit Status & Driver': 'Επεξεργασία κατάστασης & οδηγού',
  'Reorder Stops': 'Αναδιάταξη στάσεων',
  Optimize: 'Βελτιστοποίηση',
  'Search stops': 'Αναζήτηση στάσεων',
  'Delivery:': 'Παράδοση:',
  'Pickup:': 'Παραλαβή:',
  'No Stop was found': 'Δεν βρέθηκε στάση',
  'Please check it again or try another keyword': 'Ελέγξτε το ξανά ή δοκιμάστε άλλη λέξη-κλειδί',
  'Add your orders': 'Προσθέστε τις παραγγελίες σας',
  'You can add orders from orders pages': 'Μπορείτε να προσθέσετε παραγγελίες από τις σελίδες παραγγελιών',
  'Go to Orders': 'Μετάβαση στις παραγγελίες',
  'On Demand': 'Κατά παραγγελία',
  P_Hub_D: 'P_Hub_D',
  Notifications: 'Ειδοποιήσεις',
  'Admin Center': 'Κέντρο διαχείρισης',
  'Sort by': 'Ταξινόμηση κατά',
  'Sort type': 'Είδος ταξινόμησης',
  OrderType: 'Τύπος παραγγελίας',
  Stage: 'Φάση',
  Status: 'Κατάσταση',
  Route: 'Διαδρομή',
  CreatedAt: 'Δημιουργήθηκε στις',
  StatusUpdatedAt: 'Ενημέρωση κατάστασης στις',
  Note: 'Σημείωση',
  'Delivery Last Attempt Reason': 'Αιτία τελευταίας απόπειρας παράδοσης',
  'Delivery Attempts Count': 'Αριθμός προσπαθειών παράδοσης',
  'Pickup Failed Reason': 'Αιτία αποτυχίας παραλαβής',
  ReferenceId: 'Κωδικός δέματος',
  PickupAddress: 'Διεύθυνση παραλαβής',
  DeliveryAddress: 'Διεύθυνση παράδοσης',
  'Driver Name': 'Όνομα οδηγού',
  'Driver Phone': 'Τηλέφωνο οδηγού',
  'Customer Name': 'Όνομα πελάτη',
  'Customer Phone': 'Τηλέφωνο πελάτη',
  EstimatedDistanceInMeters: 'Εκτιμώμενη απόσταση σε μέτρα',
  EstimatedDuration: 'Εκτιμώμενη διάρκεια',
  'Payment Method': 'Μέθοδος πληρωμής',
  PickupAddressDetail: 'Λεπτομέρειες διεύθυνσης παραλαβής',
  PickupCompleteAfter: 'Ολοκλήρωση παραλαβής μετά',
  PickupcompleteBefore: 'Ολοκλήρωση παραλαβής πριν',
  PickupFullName: 'Όνομα αποστολέα',
  PickupPhone: 'Τηλέφωνο παραλήπτη',
  PickupEmail: 'Email παραλήπτη',
  PickupPodNote: 'Σημείωση παραλαβής',
  PickupPodPhoto: 'Φωτογραφία παραλαβής',
  PickupPodSignature: 'Υπογραφή παραλαβής',
  PickupZone: 'Ζώνη παραλαβής',
  DeliveryAddressDetail: 'Λεπτομέρειες διεύθυνσης παράδοσης',
  DeliveryCompleteAfter: 'Ολοκλήρωση παράδοσης μετά',
  DeliverycompleteBefore: 'Ολοκλήρωση παράδοσης πριν',
  DeliveryFullName: 'Όνομα παραλήπτη',
  DeliveryPhone: 'Τηλέφωνο παραλήπτη',
  DeliveryEmail: 'Email παραλήπτη',
  DeliveryPodNote: 'Σημείωση παράδοσης',
  DeliveryPodPhoto: 'Φωτογραφία παράδοσης',
  DeliveryPodSignature: 'Υπογραφή παράδοσης',
  DeliveryZone: 'Ζώνη παράδοσης',
  'Driver Vehicle': 'Όχημα οδηγού',
  'Driver Username': 'Όνομα χρήστη οδηγού',
  CustomerType: 'Τύπος πελάτη',
  'Customer Email': 'Email πελάτη',
  PaymentProvider: 'Πάροχος πληρωμών',
  Source: 'Πηγή',
  'Shipment Label': 'Ετικέτα αποστολής',
  'Track Order': 'Παρακολούθηση παραγγελίας',
  'Create your first order': 'Δημιουργήστε την πρώτη σας παραγγελία',
  'Your orders will be shown here in table with full details and actions': 'Οι παραγγελίες σας θα εμφανίζονται εδώ με όλες τις λεπτομέρειες και ενέργειες',
  'Please check your filters or keyword': 'Ελέγξτε τα φίλτρα ή τη λέξη-κλειδί σας',
  from: 'από',
  rows: 'γραμμές',
  Prev: 'Προηγούμενο',
  Next: 'Επόμενο',
  Stages: 'Στάδια',
  RouteName: 'Όνομα διαδρομής',
  Services: 'Υπηρεσίες',
  PaymentSides: 'Μέλη πληρωμής',
  pickupzones: 'Ζώνες παραλαβής',
  deliveryzones: 'Ζώνες παράδοσης',
  Zones: 'Ζώνες',
  CodAmount: 'Ποσό αντικαταβολής',
  'Payment Methods': 'Τρόποι πληρωμής',
  'Delivery Attempt Number': 'Αριθμός προσπαθειών παράδοσης',
  paymentMethods: 'Τρόποι πληρωμής',
  'Edit Status': 'Επεξεργασία κατάστασης',
  'Select Status': 'Επιλογή κατάστασης',
  'Select Reason': 'Αιτιολογία',
  'Select Route': 'Επιλογή διαδρομής',
  'Don’t change routes': 'Να μην αλλάξουν οι διαδρομές',
  'Edit routes': 'Επεξεργασία διαδρομών',
  'Remove routes': 'Αφαίρεση διαδρομών',
  'You must assign driver to select this route': 'Πρέπει να αναθέσετε οδηγό για να επιλέξετε αυτή τη διαδρομή',
  'You must choose an unassigned route or unassign selected route': 'Πρέπει να επιλέξετε μη εκχωρημένη διαδρομή ή να αφαιρέσετε την επιλεγμένη διαδρομή',
  'Create P_HUB_D Only order': 'Δημιουργία παραγγελίας P_HUB_D',
  'Add routes': 'Προσθήκη διαδρομών',
  'Your routes will be shown here in': 'Οι διαδρομές σας θα εμφανίζονται εδώ',
  'Add orders': 'Προσθήκη παραγγελιών',
  'Bulk select in orders list and add orders with edit status button': 'Μαζική επιλογή παραγγελιών και προσθήκη με επεξεργασία κατάστασης.',
  'Create Ondemand order': 'Δημιουργία παραγγελίας κατόπιν ζήτησης',
  'Your orders will be shown here in list': 'Οι παραγγελίες σας θα εμφανίζονται εδώ σε λίστα',
  'Create Pickup Only order': 'Δημιουργία παραγγελίας μόνο για παραλαβή',
  'Create Delivery Only order': 'Δημιουργία παραγγελίας μόνο για παράδοση',
  'No offline driver': 'Δεν υπάρχουν οδηγοί εκτός σύνδεσης',
  'Offline drivers will be shown here': 'Οι οδηγοί εκτός σύνδεσης θα εμφανίζονται εδώ',
  'No online driver': 'Δεν υπάρχουν οδηγοί σε σύνδεση',
  'Online drivers will be shown here': 'Οι οδηγοί σε σύνδεση θα εμφανίζονται εδώ',
  'Driver login info': 'Πληροφορίες σύνδεσης οδηγού',
  'Driver must be online in the app to see it here  and be able to assign orders': 'Ο οδηγός πρέπει να είναι σε σύνδεση για ανάθεση παραγγελιών.',
  'Scan to Download Driver app': 'Σάρωση για λήψη της εφαρμογής οδηγού',
  OR: 'Ή',
  'Open the link in your phone': 'Άνοιγμα του συνδέσμου στο τηλέφωνό σας',
  'Copy link to clipboard': 'Αντιγραφή συνδέσμου στο πρόχειρο',
  'Copied!': 'Αντιγράφηκε!',
  'Add drivers': 'Προσθήκη οδηγών',
  Pleaseselectroutefromsearchresults: 'Επιλέξτε διαδρομή από την αναζήτηση.',
  Addroutestobeabletosearchandselectroute: 'Προσθέστε διαδρομές για αναζήτηση και επιλογή.',
  NoRoutes: 'Δεν υπάρχουν διαδρομές',
  Searchandselectroute: 'Αναζήτηση και επιλογή διαδρομής',
  EDROPANDDE2: 'Επιτρέπονται μόνο μη ανατεθειμένες διαδρομές.',
  EDROPANDDE1: 'Επιτρέπονται μόνο ανατεθειμένες ή ενεργές διαδρομές.',
  selected: 'selected'
}



  /*

  export const GreekLabel = {
    "Enter_the_following_information_to_enter": "Συμπληρώστε τα στοιχεία σας για να συνδεθείτε",
    "login": "Σύνδεση",
    "Username": "Όνομα Χρήστη",
    "password": "Κωδικός",
    "Orders": "Παραγγελίες",
    "Online": "Σε Σύνδεση",
    "Offline": "Εκτός Σύνδεσης",
    "Info": "Πληροφορίες",
    "email": "Email",
    "vehicletypes": "Τύποι Υπηρεσιών",
    "loginstatus": "Κατάσταση σύνδεσης",
    "lastonlinetime": "Τελευταία ώρα σύνδεσης",
    "fetchingdata": "Εύρεση Πληροφορίας...",
    "poperLoading": "Παρακαλώ περιμένετε",
    "Noinformationfound": "Δεν βρέθηκαν πληροφορίες",
    "Drivers": "Οδηγοί",
    "otherdropoffs": "undefined",
    "paymentmethod": "Τρόπος πληρωμής",
    "Receiver": "Από παραλήπτη",
    "Sender": "Από αποστολέα",
    "Balance": "Υπόλοιπο",
    "Cash": "Μετρητά",
    "Wallet": "Πορτοφόλι",
    "Close": "Κλείσιμο",
    "noVehicleType": "Δεν υπάρχει τύπος υπηρεσίας για εμφάνιση",
    "Fname": "Όνομα",
    "Lname": "Επώνυμο",
    "Pnumber": "Τηλέφωνο",
    "driver": "Οδηγός",
    "Pleasetryanotherkeyword": "Δοκιμάστε μια άλλη λέξη-κλειδί",
    "DropOff": "Παράδοση",
    "Noaddressavailable": "Δεν υπάρχει διαθέσιμη διεύθυνση",
    "Managefavoriteaddresses": "Διαχείριση διευθύνσεων",
    "address": "Διέυθυνση",
    "Saved": "Αποθηκευμένο",
    "block": "τετράγωνο",
    "Floor": "Όροφος",
    "Unit": "Μονάδα",
    "Recieverfullname": "Όνομα Αποστολέα",
    "Recieverphonenumber": "Τηλέφωνο Παραλήπτη",
    "notesfordriver": "Σημείωση για τον οδηγό",
    "Price": "Τιμή",
    "EditOrder": "Επεξεργασία Παραγγελίας",
    "Firstname": "Όνομα",
    "Lastname": "Επώνυμο",
    "Phonenumber": "Τηλέφωνο",
    "senderfullname": "Όνομα Αποστολέα",
    "senderphonenumber": "Τηλέφωνο Αποστολέα",
    "Search": "Αναζήτηση",
    "Service": "Υπηρεσία",
    "Passenger": "Πελάτης",
    "Pickup": "Σημείο Παραλαβής",
    "Pricedetails": "Λεπτομέρειες τιμής",
    "Fee": "Χρέωση",
    "Fornow": "Άμεσα",
    "Scheduled": "Προγραμματισμένο",
    "before": "Πριν:",
    "Settime": "Καταχώρηση ώρας",
    "after": "Μετά:",
    "confirm": "Επιβεβαίωση",
    "Cancel": "Ακύρωση",
    "Addresses": "Διευθύνσεις",
    "Savedaddresses": "Αποθηκευμένες Διευθύνσεις",
    "new": "Νέα",
    "Editaddress": "Επεξεργασία διεύθυνσης",
    "Saveaddress": "Αποθήκευση διεύθυνσης",
    "Language": "Γλώσσα",
    "en": "English",
    "fa": "Persian",
    "English": "English",
    "Persian": "Persian",
    "Logout": "Αποσύνδεση",
    "logotTitle": "Αποσύνδεση απο τον λογαριασμό σας ?",
    "logoutDescription": "Θα αποσυνδεθείτε απο τον λογαριασμό και θα απαιτείτε εκ νέου σύνδεση",
    "confirmLogout": "Επιβεβαίωση",
    "skipLogout": "Ακύρωση",
    "Ascending": "Αύξουσα",
    "Descending": "Φθίνουσα",
    "sort[createdAt]": "Ημερομηνία",
    "sort[pickupScheduleDate]": "Ώρα προγραμματισμένης παραλαβής",
    "sort[statusUpdatedAt]": "Ταξινόμηση κατά ενημέρωση",
    "SelectDateRange": "Εύρος ημερομηνιών",
    "StartDate": "Ημερομηνία Έναρξης",
    "EndDate": "Ημερομηνία Λήξης",
    "Today": "Σήμερα",
    "Yesterday": "Χθες",
    "ThisWeek": "Αυτή την εβδομάδα",
    "LastWeek": "Προηγούμενη εβδομάδα",
    "Last7Days": "Τελευταίες 7 ημέρες",
    "ThisMonth": "Αυτός ο Μήνας",
    "LastMonth": "Προηγούμενος Μήνας",
    "monitoring": "Παρακολούθηση",
    "Haveorder": "Υπάρχει Παραγγελία",
    "Estimated": "Εκτιμώμενος",
    "ReceiverCash": "Μετρητά (παραλήπτη)",
    "SenderCash": "Μετρητά",
    "SenderWallet": "Πορτοφόλι",
    "Auto": "Αυτόματα",
    "Manual": "Χειρ/νητα",
    "SendOrderr": "Αποστολή",
    "Neworder": "Νέα Παραγγελία",
    "Person": "Ιδιώτης",
    "Business": "Επιχείρηση",
    "Businessname": "Όνομα Επιχείρησης",
    "phonenumber": "Τηλέφωνο",
    "Adddropoff": "Προσθήκη σημείου παράδοσης",
    "Searchbynameorphonenumber": "Αναζήτηση σύμφωνα με όνομα ή τηλέφωνο",
    "Fullname": "Όνομα/Επώνυμο",
    "type": "πληκτρολόγηση",
    "only": "xxx μόνο",
    "ChooseDriver": "Επιλογή Οδηγού",
    "AllKey": "Όλες",
    "MeKey": "Εγώ",
    "Vehicletype": "Τύπος οχήματος",
    "status": "Κατάσταση",
    "statusInProgress": "Σε εξέλιξη",
    "statusCanceled": "Ακυρώθηκε",
    "statusPending": "Σε εκκρεμότητα",
    "statusUnassigned": "Χωρίς Ανάθεση",
    "statusDone": "Ολοκληρωμένες",
    "dispatcher": "χειριστής",
    "customer": "τηλέφωνο",
    "regexcode": "Κωδικός",
    "regexcustomerPhone": "Ακυρώθηκε από πελάτη",
    "regexcustomerName": "Τηλέφωνο Πελάτη",
    "regexdriverPhone": "Τηλέφωνο Οδηγού",
    "regexdriverName": "Όνομα Οδηγού",
    "regexdriverUsername": "Όνομα Χρήστη Οδηγού",
    "pickupDescription": "Περιγραφή σημείου παραλαβής",
    "filter": "Φίλτρο",
    "clear": "Καθαρισμός",
    "orderInfoError": "Βλάβη εύρεσης πληροφορίας",
    "Details": "Λεπτομέρειες",
    "History": "Ιστορικό",
    "Phone": "Τηλέφωνο",
    "km": "χλμ",
    "Espath": "Εκτ.Διαδρομή",
    "Receipt": "Απόδειξη",
    "Copylink": "Αντιγραφή συνδέσμου",
    "repeatOrder": "Επανάληψη Παραγγελίας",
    "Edit": "Επεξεργασία",
    "EditPrice": "Επεξεργασία τιμής",
    "Endtrip": "Ολοκλήρωση παραγγελίας",
    "Canceltravel": "Ακύρωση παραγγελίας",
    "CancellText": "Έπειτα της ακύρωσης, η παραγγελία ακυρώνεται και για τον οδηγό.",
    "confirmCancel": "Ναι",
    "Endtravel": "Ολοκλήρωση",
    "EndlText": "undefined",
    "confirmEnd": "Ναι",
    "End": "Ακύρωση Παραγγελίας",
    "Deliveredat": "Παραδόθηκε σε",
    "pod": "Αποδεικτικό παράδοσης",
    "Notes": "Σημείωση",
    "Nonotes": "Καμία σημείωση",
    "Photo": "Φωτογραφία",
    "Signature": "Υπογραφή",
    "Nosignature": "Καμία υπογραφή",
    "Nophoto": "Καμία φωτογραφία",
    "ServiceOptions": "Επιλογές υπηρεσίας",
    "Events": "Γεγονότα",
    "status2": "κατάσταση",
    "Creator": "Δημιουργός",
    "Creationdate": "Ημερομηνία δημιουργίας",
    "Orderid": "ID παραγγελίας",
    "Pickup2": "Σημείο Παραλαβής",
    "Dropoff2": "Σημείο Παράδοσης",
    "PleaseSelect": "Παρακαλώ Επιλέξτε",
    "CreateEvent": "Δημιουργία Γεγονότος",
    "Description": "Περιγραφή",
    "detailsAboutEvent": "Λεπτομέρειες γεγονότος",
    "CustomerVisibility": "Όρατότητα πελάτη",
    "LocationOnMap": "Τοποθεσία στον χάρτη",
    "undefined": "undefined",
    "Pending": "Σε εκρεμμότητα",
    "Unassigned": "Χωρίς Ανάθεση",
    "Assigned": "Σε εξέλιξη",
    "PickedUp": "Σε εξέλιξη",
    "Started": "Σε εξέλιξη",
    "Done": "Ολοκληρώθηκε",
    "CustomerCanceled": "Ακυρώθηκε",
    "DriverCanceled": "Ακυρώθηκε",
    "SupportCanceled": "Ακυρώθηκε",
    "Arrived": "Σε εξέλιξη",
    "Createdsuccessfully": "Δημιουργήθηκε επιτυχώς",
    "Estime": "Εκτιμώμενος χρόνος",
    "Promocode": "Κουπόνι",
    "Updatedsuccessfully": "Ενημερώθηκε επιτυχώς",
    "statusAssigned": "Ανατέθηκε",
    "statusStarted": "Ξεκίνησε",
    "statusPickedUp": "Ξεκίνησε",
    "statusDriverCanceled": "Ακυρώθηκε από οδηγό",
    "statusArrived": "Έφτασε",
    "statusSupportCanceled": "Ακυρώθηκε απο Διαχείριση",
    "Title": "Τίτλος",
    "ContactFullname": "Όνομα Επαφής",
    "Contactphonenumber": "Τηλέφωνο Επαφής",
    "Commission": "Απόδοση",
    "surcharge": "Επιπλέον χρέωση",
    "haslogined": "έχει συνδεθεί",
    "Notloggedin": "δεν έχει συνδεθεί",
    "Schedule": "Προγρ/σμός",
    "Date": "Ημερομηνία",
    "Time": "Ώρα",
    "noDateToShow": "Δεν υπάρχει ημερομηνία προς προβολή",
    "noTimeToShow": "Δεν υπάρχει ώρα προς προβολή",
    "Apply": "Επιβεβαίωση",
    "lowBalance": "Χαμηλό υπόλοιπο",
    "balanceError": "Το υπόλοιπο σας πρέπει να είναι τουλάχιστον ίσο με το κόστος της παραγγελίας",
    "Methods": "Τρόποι Πληρωμής",
    "Addressbook": "Αποθηκευμένες Διευθύνσεις",
    "AddressbookSearchbar": "Αναζήτηση βάση διεύθυνσης, τίτλου και ID",
    "AddressbookDropOf": "Αποθ/μένες Διευθύνσεις",
    "AddressbookPickup": "Αποθ/μένες Διευθύνσεις",
    "hide": "Hide",
    "Nosavedaddress": "Δεν υπάρχουν αποθηκευμένες διευθύνσεις",
    "Romanian": "Romanian",
    "business": "Επιχείρηση",
    "username": "Όνομα Χρήστη",
    "rememberme": "Θυμήσου με",
    "SendOrder": "Αποστολή",
    "code": "Κωδικός",
    "noorder": "καμία παραγγελία",
    "pleaseSellectParsel": "Επιλέξτε Υπηρεσία",
    "Order": "Παραγγελία",
    "Code": "Κωδικός",
    "Editorder": "Επεξεργασία Παραγγελίας",
    "all": "Όλες",
    "Address": "Διευθύνσεις",
    "Block/Building": "Τετράγωνο/Κτήριο",
    "Pickedupat": "Παραλήφθηκε σε",
    "for": "Για",
    "fr": "French",
    "AllVehicletypes": "Όλοι τύποι υπηρεσιών",
    "AllServices": "Όλες οι Υπηρεσίες",
    "French": "French",
    "enterDataCorrectly": "Καταχωρήστε τα στοιχεία σωστά",
    "controlThatbeforeLoweEqualAfter": "Η Ώρα \"Πριν:\" δεν μπορεί να είναι νωρίτερα από \" Μετά:\"",
    "ForceAssign": "Αναγκαστική Ανάθεση",
    "Allvehicletypes": "Όλοι τύποι οχημάτων",
    "waitforconfirm": "xxx (Αναμονή Επιβεβαίωσης)",
    "waitforconfirm2": "(Αναμονή Επιβεβαίωσης)",
    "Dispatching": "Αποστολή",
    "NoDriver": "Κανένας Οδηγός",
    "OtherDetails": "Άλλες Λεπτομέρειες",
    "StatusandDriver": "Κατάσταση και Οδηγός",
    "EditStatusandDriver": "Επεξεργασία Κατάστασης και Οδηγού",
    "Current": "Τρέχων",
    "EDAS_Pending": "Σε εξέλιξη",
    "EDAS_Assigned": "Ανατέθηκε",
    "EDAS_PickedUp": "Παραλήφθηκε",
    "EDAS_Unassigned": "Χωρίς Ανάθεση",
    "EDAS_Started": "Ξεκίνησε",
    "EDAS_Done": "Ολοκληρώθηκε",
    "EDAS_CustomerCanceled": "Ακύρωση από πελάτη",
    "EDAS_DriverCanceled": "Ακύρωση από οδηγό",
    "EDAS_SupportCanceled": "Ακύρωση από Υποστήριξη",
    "EDAS_Arrived": "Έφτασε",
    "Pleasechooseadrivertochangestatus": "Η Αλλαγή επιλογών μπορεί να επηρεάσει την τιμή",
    "icWarningEdit": "Ο τύπος οχήματος θα αλλάξει",
    "Vehicletypewillbechanged": "Ο τύπος οχήματος θα αλλάξει και θα επηρεάσει την τελική τιμή",
    "Yourcurrentvehicletypeanditwillbechangedandeffectsonprice": "Ο τρέχων τύπος οχήματος θα αλλάξει και θα επηρεάσει την τιμή",
    "Rejected": "Απορρίφθηκε",
    "Rejected2": "(Απορρίφθηκε)",
    "DriverVehicleTypeError": "Δεν υπάρχει τύπος οχήματος για τον οδηγό",
    "CodeNameFamilyPhonenumber": "Κωδικός, Όνομα, Τηλέφωνο",
    "youcanselectdriverintheedit": "Μπορεί να επιλεχθεί οδηγός στην Επεξεργασία Κατάστασης και Οδηγού",
    "Earning": "Κέρδος",
    "savePrice": "Αποθήκευση τιμής",
    "saveEarning": "Αποθηκευση κέρδους",
    "Total": "Σύνολο",
    "EditPickupDropOff": "Edit Addresses",
    "noMoreData": "Δεν υπάρχουν άλλες πληροφορίες",
    "OnDemand": "Κατα παραγγελία",
    "PD": "P & D",
    "PD2": "P&D",
    "PickupDropoff": "Παραλαβή, Παράδοση",
    "PickupFlag": "P",
    "DropOffFlag": "D",
    "PickupandDelivery": "Παραλαβή και Παράδοση",
    "PickupDelivery": "Παραλαβή και Παράδοση",
    "Delivery": "Παράδοση",
    "Collecting": "Περισυλλογή",
    "Transit": "Σε μεταφορά",
    "Delivering": "Προς παράδοση",
    "EDAS_Collecting": "Περισυλλογή",
    "EDAS_Transit": "Σε μεταφορά",
    "EDAS_Delivering": "Προς παράδοση",
    "statusCollecting": "Περισυλλογή",
    "statusTransit": "Σε μεταφορά",
    "statusDelivering": "Προς παράδοση",
    "serviceCustomerError1": "xxx δεν είναι διαθέσιμη για αυτόν τον πελάτη",
    "serviceCustomerError2": "Μπορεί να επιλέξει μόνο τη xxx Υπηρεσία",
    "serviceCustomerError3": "Μπορεί να επιλέξει μόνο xxx",
    "OrderCode": "Κωδικός Παραγγελίας",
    "event_Created": "Δημιουργήθηκε",
    "event_Unassigned": "Χωρίς Ανάθεση",
    "event_Assigned": "Ανατέθηκε",
    "event_Started": "Ξεκίνησε",
    "event_Arrived": "Έφτασε",
    "event_PickedUp": "Παραλήφθηκε",
    "event_OrderDone": "Παραγγελία ολοκληρώθηκε",
    "event_DropoffDone": "Έγινε Παράδοση",
    "event_CustomerFeedback": "Ανατροφοδότηση Πελάτη",
    "event_AddPod": "Προσθήκη απόδειξης παράδοσης",
    "event_CustomerCanceled": "Ο πελάτης Ακύρωσε",
    "event_DriverCanceled": "Ο οδηγός ακύρωσε",
    "event_SupportCanceled": "Η υποστήριξη ακύρωσε",
    "event_Updated": "Ενημερώθηκε",
    "event_DriverAssignment": "Ανάθεση Οδηγού",
    "event_DriverReject": "Αππόριψη από οδηγό",
    "event_Collecting": "Περισυλλογή",
    "event_InTransit": "Σε μεταφορά",
    "event_Delivering": "Προς παράδοση",
    "event": "Γεγονός",
    "tab_Delivery": "Παράδοση",
    "tab_Ondemand": "Κατά παραγγελία",
    "tab_Pickup": "Σημείο Παραλαβής",
    "tab_PickupDelivery": "P&D",
    "CurrentStatus": "Τρέχουσα Κατάσταση",
    "Changestatus": "Αλλαγή κατάστασης",
    "Newstatus": "Νέα κατάσταση",
    "Savechanges": "Αποθήκευση αλλαγών",
    "Other": "Άλλα",
    "Shipmentlabel": "Ετικέτα αποστολής",
    "pleaseSellectService": "Επιλέξτε είδος υπηρεσίας",
    "EditPrice2": "Τιμή",
    "EditEarning": "Κέρδος",
    "statusCustomerCanceled": "Ακυρώθηκε απο πελάτη",
    "Dutch": "Dutch",
    "Ondemand": "Κατά παραγγελία",
    "todayat": "Σήμερα στις",
    "tomorrowat": "Αύριο στις",
    "nextWeekat": "Την επόμενη εβδομάδα στις",
    "lastDayat": "Χθες στις",
    "lastWeekat": "Την προηγούμενη εβδομάδα στις",
    "CopyOrderlink": "Αντιγραφή συνδέσμου παραγγελίας",
    "CopyPickuplink": "Αντιγραφή συνδέσμου παραλαβής",
    "CopyDeliverylink": "Αντιγραφή συνδέσουμε παράδοσης",
    "Bulkimport": "Μαζική εισαγωγή",
    "Downloadsamplecsv": "Κατεβάστε ένα δείγμα CSV",
    "processing": "Επεξεργασία",
    "done": "Ολοκληρώθηκε",
    "failed": "Απέτυχε",
    "Draft": "Πρόχειρο",
    "Uploading": "Μεταφόρτωση",
    "Draganddropyourfile": "Σύρετε και αφήστε το αρχείο σας",
    "Onlycsvformatissupported": "Μόνο αρχεία .csv υποστηρίζονται",
    "ORyoucan": "Ή μπορείτε",
    "Openfile": "Άνοιγμα αρχείου",
    "Noimportsyet": "Καμία μεταφόρτωση ακόμα",
    "NoimportsyetDesc": "Μπορείτε να δείτε τη λίστα με τις εισαγωγές σας εδώ και να ελέγξετε την κατάστασή τους",
    "nosupportdialogeTitle": "Αυτός ο τύπος αρχείου δεν υποστηρίζεται",
    "nosupportdialogeText": "Το αρχείο xxx δεν υποστηρίζεται. Μπορείτε να ανεβάσετε μόνο αρχείο .csv συμπεριλαμβανομένων των πληροφοριών παραγγελίας",
    "ok": "OK",
    "Import": "Εισαγωγή",
    "previewTitle": "Προεπισκόπηση και επιλογή",
    "previewDesc": "Αυτό είναι το πρώτο στοιχείο των αρχείων σας για να ελέγξετε ότι οι πληροφορίες σας είναι στη σωστή δομή",
    "Upload": "Μεταφόρτωση",
    "Remove": "Αφαίρεση",
    "ServiceandOrdertype": "Υπηρεσία και Τύπος Παραγγελίας",
    "Fileisproccessing": "Γίνεται επεξεργασία του αρχείου...",
    "proccessingDesc": "Μπορείτε να κάνετε ανανέωση για να δείτε αν το αποτέλεσμα είναι έτοιμο",
    "serverError": "Σφάλμα Διακομιστή",
    "isRequired": "xxx είναι απαραίτητο",
    "Result": "Αποτέλεσμα",
    "ResultText": "Μπορείτε να δείτε τα προβλήματα εδώ και μπορείτε επίσης να κάνετε λήψη αυτών των σειρών για να τα διορθώσετε",
    "ErrorDetails": "Παραγγελίες με σφάλμα",
    "ErrorDetailsText": "Οι παραγγελίες με σφάλματα παρατίθενται στο αρχείο που μπορείτε να κατεβάσετε παρακάτω. Περιέχει λεπτομέρειες σφάλματος για κάθε σειρά.",
    "DownloadErroredRows": "Κατεβάστε τις εσφαλμένες γραμμές",
    "importedsuccessfully": "xxx παραγγελίες έχουν εισαχθεί επιτυχώς",
    "ordershaserrors": "xxx παραγγελίες έχουν σφάλμα",
    "refresh": "Ανανέωση",
    "CashOnDelivery": "Αντικαταβολή",
    "EnterAmount": "Συμπληρώστε το ποσό",
    "COD": "Ανικαταβολή",
    "Surchargexxx": "Έξτρα Χρέωση xxx",
    "AddCreditCard": "Προσθήκη Χρεωστικής Κάρτας",
    "CustomerWallet": "Πορτοφόλι πελάτη",
    "Add": "Προσθήκη",
    "Addedsuccessfully": "Προστέθηκαν επιτυχώς",
    "NoRecentAddress": "Καμία πρόσφατη διεύθυνση",
    "NoRecentAddressD": "Οι τελευταίες διευθύνσεις του πελάτη θα αναφέρονται εδώ",
    "CustomerIsNotChoosed": "Δεν έχει επιλεχθεί πελάτης",
    "CustomerIsNotChoosedD": "Επιλέξτε έναν πελάτη για εμφάνιση (προβολή) της τελευταίας διεύθυνσης",
    "SearchAddress": "Αναζήτηση διεύθυνσης",
    "NoCustomerfound": "Δεν βρέθηκε πελάτης",
    "NoCustomerfoundD": "Εάν ο πελάτης είναι νέος, μπορείτε να τον καταχωρήσετε",
    "NewCustomer": "Νέος Πελάτης",
    "Existing": "Υπάρχον",
    "EmailOtional": "Email (Προεραιτικό)",
    "phonenumberisnotcorrect": "ο αριθμός τηλεφώνου δεν είναι σωστός",
    "Emailisnotcorrect": "Το Email δεν είναι σωστό",
    "Registercustomer": "Εγγραφή πελάτη",
    "incoming": "Εισερχόμενη κλήση",
    "outgoing": "Εξερχόμενη κλήση",
    "recording": "Καταγραφή κλήσης",
    "driveroperatorCallStatus": "Ο οδηγός κάλεσε τον διαχειριστή",
    "customeroperatorCallStatus": "Ο πελάτης κάλεσε τον διαχειριστή",
    "newCustomeroperatorCallStatus": "Νέος πελάτης κάλεσε τον διαχειριστή",
    "operatordriverCallStatus": "Διαχειριστής κάλεσε τον οδηγό",
    "operatorcustomerCallStatus": "Ο διαχειριστής κάλεσε τον πελάτη",
    "operatornewCustomerCallStatus": "Ο διαχειριστής κάλεσε τον νέο πελάτη",
    "dispatcher_Voip": "Διαχειριστής",
    "driver_Voip": "Οδηγός",
    "customer_Voip": "Πελάτης",
    "activeorders": "xxx ενεργές παραγγελίες",
    "Noactiveorder": "Καμία ενεργή παραγγελία",
    "CreateOrder": "Δημιουργία Παραγγελίας",
    "call": "Κάλεσε",
    "spanish": "Spanish",
    "es": "Spanish",
    "networkError": "Δεν υπάρχει σύνδεση στο διαδίκτυο",
    "germany": "Germany",
    "de": "Germany",
    "Itisnotpossibletorepeattherequest": "Η παραγγελία δεν μπορεί να επαναληφθεί",
    "createdAt": "Δημιουργήθηκε στις",
    "dueDate": "Ημερομηνία λήξης",
    "Noresultfound": "Δεν βρέθηκε κάποιο αποτέλεσμα",
    "loadMore": "Περισσότερα",
    "Searchresult": "Αναζήτηση αποτελέσματος",
    "AssignedAt": "Ανάθεση xxx",
    "StartedAt": "Εκκίνηση xxx",
    "ArrivedAt": "Έφτασε xxx",
    "PickedUpAt": "Παραλήφθηκε xxx",
    "DoneAt": "Ολοκληρώθηκε xxx",
    "mindelay": "xxxm καθυστέρηση",
    "minlate": "xxxm καθυστέρηση",
    "PinTop": "Πινέζα",
    "UnPin": "Πινέζα",
    "Itemsonmap": "Αντικείμενα στον χάρτη",
    "min": "xxx λεπτά",
    "Confirming": "Γίνεται επιβεβαίωση",
    "delay": "Καθυστέρηση",
    "late": "Καθυστέρηση",
    "OrderDetails": "Λεπτομέρειες Παραγγελίας",
    "Profile": "Προφίλ",
    "Waitingforavailabledrivers": "Σε αναμονή ενεργών οδηγών",
    "Queue": "Σειρά",
    "OfferingToDrivers": "Προσφορά σε οδηγούς xxx",
    "WaitforAccept": "Αναμονή Αποδοχής",
    "Thereisnoorder": "Δεν υπάρχει παραγγελία",
    "mapitems": "Αντικείμενα χάρτη",
    "Offerings": "Προσφορές",
    "Reject": "Απόρριψη",
    "dropoffCustomerDescription": "Σημείωση Παράδοσης",
    "customerPhoto": "Φωτογραφία Πελάτη",
    "driverPhoto": "Φωτογραφία Οδηγού",
    "NocustomerPhoto": "Καμία Φωτογραφία Πελάτη",
    "NodriverPhoto": "Καμία Φωτογραφία Οδηγού",
    "initial": "αρχική",
    "notifying": "προειδοποίηση",
    "received": "παραλήφθηκε",
    "assigned": "ανατέθηκε",
    "rejected": "απορρίφθηκε",
    "canceled": "ακυρώθηκε",
    "standby": "σε αναμονή",
    "terminated": "τερματίστηκε",
    "urgentTitle": "Αντικατάσταση με Επείγον παράδοση?",
    "urgentDesc": "Αν η παραγγελία χαρακτηριστεί ώς επείγον τότε θα έχει προτεραιότητα για αποστολή",
    "urgentConfirm": "Ναι, ενεργοποίηση \\\"Επείγον\\\"",
    "urgentClose": "Ακύρωση",
    "Urgent": "Επείγον",
    "photos": "Φωτογραφίες",
    "Portuguese": "Portuguese",
    "Dispatchat": "Αποστολή κατά xxx",
    "AutoDispatch": "Αυτόματη αποστολή",
    "Dispatchtime": "Χρόνος αποστολής",
    "Later": "Αργότερα",
    "DispatchingNow": "Αποστολή τώρα",
    "NoResultfromLocalDatabase": "Κανένα αποτέλεσμα από την τοπική βάση δεδομένων",
    "NoResultfromLocalDatabaseD": "Ελέγξτε ξανά ή δοκιμάστε άλλη λέξη-κλειδί",
    "NoResultfromMapService": "undefined",
    "now": "Τώρα",
    "ascending": "Αύξουσα",
    "descending": "Φθίνουσα",
    "Last3Month": "Τελευταίοι 3 Μήνες",
    "Pickupnote": "Σημείωση Παραλαβής",
    "pop": "Αποδεικτικό Παραλαβής",
    "Required": "Απαιτείται",
    "SearchinMapService": "Αναζήτηση στον χάρτη",
    "SearchinLocalDatabase": "Αναζήτηση στην Τοπική βάση δεδομένων",
    "Creditcardnotadded": "Δεν έχει προστεθεί Τραπεζική Κάρτα",
    "OptimizeDropoffs": "Βελτιστοποίηση Παραδόσεων",
    "Greek": "Ελληνικά",
    "el": "Ελληνικά",
    "ReferenceID":"Αναγνωριστικό αναφοράς",
    "EnterId":"Εισαγάγετε ταυτότητα",
    "de":"Γερμανός",
    "German":"Γερμανός",
    "AustrianGerman":"Αυστριακό γερμανικό",
    "Options":"Επιλογές",
    "VehicleOptions":"Επιλογές οχήματος",
    "EditCustomer":"Επεξεργασία πελάτη",
    "NoDriverfound":"Δεν βρέθηκε κανένας οδηγός",
    "NoDriverfoundDesc":"Ελέγξτε τα στοιχεία σας και δοκιμάστε κάτι άλλο",
    "ClearField":"Διαυγές πεδίο",
    "Map":"Χάρτης",
    "Local":"Τοπικός",
    "CompleteRequiredFeileds":"Πλήρης απαιτούμενα πεδία",
    "Senderinfo":"Πληροφορίες αποστολέα",
    "SchedulePickup(Optional)":"Προγραμματίστε παραλαβή (προαιρετικό)",
    "ScheduleDelivery(Optional)": "Schedule Delivery (Optional)",
    "AddDropoff":"Προσθήκη πτώσης",
    "EditPrice":"Επεξεργασία τιμής",
    "Promotion":"Προβολή",
    "tax":"Φόρος",
    "surcharge":"Προσαύξηση xxx",
    "Receiverinfo":"Πληροφορίες δέκτη",
    "tryagain":"Something went wrong, please try again",
    "Selected date and time":"Selected date and time",
    "Reorder stops":"Reorder stops",
    "Bulk Edit Status Summary":"Bulk Edit Status Summary",
    "Successful":"Successful",
    "Failed":"Failed",
    "Order ID":"Order ID",
    "Details":"Details",
    "Result":"Result",
    "Pickup Routed":"Pickup Routed",
    "Delivery Routed":"Delivery Routed",
    "Ref. xxx":"Ref. xxx",
    "Zone":"Zone",
    "Clear":"Clear",
    "Apply":"Apply",
    "No result found":"No result found",
    "Type your keyword":"Type your keyword",
    "Type in the input to start search":"Type in the input to start search",
    "We are sorry ...":"We are sorry ...",
    "The page you are trying to access has restricted access.":"The page you are trying to access has restricted access.",
    "Please refer to your system administrator.":"Please refer to your system administrator.",
    "Failed":"Failed",
    "Done": "Done",
    "Schedule":"Schedule",
    "Proof of delivery":"Proof of delivery",
    "Signature":"Signature",
    "Driver Photo":"Driver Photo",
    "Notes":"Notes",
    "Order Info":"Order Info",
    "Order":"Order",
    "Price":"Price",
    "P_HUB_D Orders":'P_HUB_D Orders',
    "Routes":"Routes",
    "Default pickup":"Default pickup",
    'More':'More',
    'Route name':'Route name',
    'Driver':'Driver',
    'Pickup Orders':'Pickup Orders',
    'Delivery Orders':'Delivery Orders',
    'Ready For Pickup':'Ready For Pickup',
    'PricingAndEarning':"Pricing & Earning",
    "Pricing" : "Pricing",
    "save":"Save",
    "Learn":"Learn",
    "Scheduleoverlap":"The Schedule Pickup time must be before the Schedule Delivery time and have no overlap",
    "PleaseSelectCustomer":"Please select customer",
    "NoRegisteredCustomer":"No registered customer",
    "CreateAtLeastOneCustomerToCreateOrder":"Create at least one customer to create order"
};


  */